import { InventoryTypeEnum } from '@ztechapps/common.contract'

export const InventoryType = {
  sale: {
    value: InventoryTypeEnum.Sale,
    description: 'Inventory changes comes from sales. A deduction (negative value) for the inventory.',
  },
  reQuote: {
    value: InventoryTypeEnum.ReQuote,
    description:
      'Inventory changes if the order is paid or packing and set back the status to quote. A deduction (positive value) for the inventory.',
  },
  saleCancel: {
    value: InventoryTypeEnum.SaleCancellation,
    description:
      'Inventory changes comes from sales, a cancellation happens. A deduction (positive value) for the inventory.',
  },
  purchase: {
    value: InventoryTypeEnum.Purchase,
    description:
      'Inventory changes comes from purchase/re-stock of product. A addition (positive values) for the inventory.',
  },
  purchaseCancel: {
    value: InventoryTypeEnum.PurchaseCancellation,
    description: 'Inventory changes comes from purchase, a cancellation happens. A deduction for the inventory.',
  },
  build: {
    value: InventoryTypeEnum.Build,
    description:
      'Inventory changes comes from building new product from assembly. A addition (positive values) for the inventory.',
  },
  buildConsumption: {
    value: InventoryTypeEnum.BuildConsumption,
    description:
      'Inventory changes comes from consuming components during production. A deduction (negative value) for the inventory.',
  },
  destruct: {
    value: InventoryTypeEnum.Destruct,
    description:
      'Inventory changes comes from destructing existing product. A addition (negative values) for the inventory.',
  },
  adjustment: {
    value: InventoryTypeEnum.Adjustment,
    description:
      'Inventory adjustment like when the product is spoiled or broken, sale is cancelled, so it has to manually update the inventory count. A positive or negative value are accepted.',
  },
  initialize: {
    value: InventoryTypeEnum.Initialize,
    description: 'The initial value for the product inventory. It is normally a positive value.',
  },
  logistic: {
    value: InventoryTypeEnum.Logistic,
    description: 'Inventory changes comes from logistic.',
  },
  logisticCancel: {
    value: InventoryTypeEnum.LogisticCancellation,
    description: 'Inventory changes comes from logistic, a cancellation happens. A deduction for the inventory.',
  },
  salesReturn: {
    value: InventoryTypeEnum.SalesReturn,
    description: 'Inventory comes back from a confirmed sales return.',
  },
}
